import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

export const ServicesStrip = () => (
    <section data-testid="home-services-strip" className="py-20 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
            <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-16">
                <Reveal className="lg:col-span-4">
                    <div className="flex items-center gap-4">
                        <span className="font-mono text-sm text-terra">04</span>
                        <span className="h-px w-10 bg-terra/50" />
                        <span className="text-xs uppercase tracking-[0.25em] text-timber">What We Do</span>
                    </div>
                    <h2 className="mt-6 font-serif text-2xl font-normal leading-snug tracking-tight text-ink sm:text-3xl lg:text-4xl">
                        End-to-End, Under One Roof
                    </h2>
                    <p className="mt-6 text-base font-light leading-relaxed text-mute">
                        From concept to civil works—design, engineering, and execution held by one
                        accountable team.
                    </p>
                    <Link
                        to="/services"
                        data-testid="home-services-link"
                        className="group mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-wood transition-colors hover:text-terra"
                    >
                        How we work & full services
                        <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                </Reveal>
                <div className="lg:col-span-8">
                    <ul className="border-t border-wood/10">
                        {SERVICES.map((s, i) => (
                            <Reveal key={s.id} delay={0.04 * i} y={12}>
                                <li>
                                    <Link
                                        to="/services"
                                        data-testid={`home-service-${s.id}`}
                                        className="group flex items-baseline gap-6 border-b border-wood/10 py-5 transition-colors duration-300 hover:bg-sand md:px-4"
                                    >
                                        <span className="font-mono text-xs text-terra">{s.number}</span>
                                        <span className="font-serif text-lg font-medium text-ink transition-transform duration-500 group-hover:translate-x-2 sm:text-xl">
                                            {s.title}
                                        </span>
                                    </Link>
                                </li>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    </section>
);
